import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import ScrollToTop from './components/ScrollToTop';
import * as serviceWorker from './serviceWorker';

import "./assets/scss/material-kit-react.scss?v=1.8.0";


ReactDOM.render(
    <BrowserRouter basename={window.location.pathname || ''}>
        <ScrollToTop/>
        <App />
    </BrowserRouter>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();